import React, { useCallback, useRef, useState } from 'react';
import { ATMButton, ATMModal } from 'shared-it-appmod-ui';
import {
  ToastError,
  ToastSuccess,
} from 'src/components/atoms/toaster/toaster.component';
import Lang from 'src/libraries/language';
import { useFlightOperatorContext } from 'src/contexts/flight-operator.context';
import { IFlightOperatorForm } from 'src/models/flight-operator.model';
import { getFlightOperatorStatus } from 'src/selectors/flight-operator.selector';
import { actionTypes } from 'src/ducks/flight-operator.duck';
import FlightOperatorsForm from '../flight-operators-form/flight-operators-form.component';
import style from '../flight-operators-list/flight-operators-list.module.scss';

const FlightOperatorsAdd: React.FC = () => {
  const { state, actions } = useFlightOperatorContext();
  const [isAddOpen, setIsAddOpen] = useState(false);
  const [isDirty, setIsDirty] = useState(false);
  const formRef = useRef<HTMLFormElement>(null);

  const defaultValues: Partial<IFlightOperatorForm> = {
    name: '',
    email: '',
    operatorId: 0,
    activeFlag: true,
    dispatchFlag: true,
  };

  const addStatus = getFlightOperatorStatus(
    state,
    actionTypes.FLIGHT_OPERATOR_ADD
  );

  const handleSave = useCallback(() => {
    if (formRef && formRef.current) {
      formRef.current.handleSubmit();
    }
  }, [formRef]);

  const handleSubmit = useCallback(
    async (data) => {
      const formData: IFlightOperatorForm = {
        name: data.name,
        email: data.email,
        activeFlag: data.activeFlag,
        dispatchFlag: data.dispatchFlag,
      };
      const response = await actions.addPOST(formData);
      if (!response.error) {
        ToastSuccess(
          Lang.formatString(
            Lang.MSG_FLIGHT_OPERATOR_ADD_SUCCESS,
            formData.name ? formData.name : data.name
          )
        );
      } else {
        ToastError(response.error.message);
      }
      setIsAddOpen(false);
      actions.listGET();
    },
    [actions, setIsAddOpen]
  );

  return (
    <ATMModal
      open={isAddOpen}
      size="tiny"
      trigger={
        <ATMButton
          basic
          color="blue"
          content={Lang.LBL_NEW}
          icon="plus"
          floated="right"
          onClick={() => setIsAddOpen(true)}
        />
      }
      header={Lang.LBL_ADD_FLIGHT_OPERATOR}
      content={
        <div className={style.content}>
          <FlightOperatorsForm
            defaultValues={defaultValues}
            formRef={formRef}
            handleSubmit={handleSubmit}
            handleEnable={(value) => {
              setIsDirty(value);
            }}
          />
        </div>
      }
      actions={
        <div className={style.actionBtns}>
          <ATMButton
            basic
            color="blue"
            content={Lang.LBL_CANCEL}
            onClick={() => {
              setIsAddOpen(false);
            }}
          />
          <ATMButton
            primary
            content={Lang.LBL_SAVE}
            disabled={!isDirty || addStatus.fetching}
            onClick={handleSave}
            loading={addStatus.fetching}
          />
        </div>
      }
    />
  );
};

export default FlightOperatorsAdd;
